import * as React from 'react';

export function useCombinedRefs<T>(...refs: Array<React.Ref<T>>) {
  const targetRef = React.useRef<T>(null);

  React.useEffect(() => {
    refs.forEach((ref) => {
      if (!ref) return;

      const currentRef = ref;

      if (typeof currentRef === 'function') {
        currentRef(targetRef.current);
      } else {
        (currentRef as React.MutableRefObject<T | null>).current =
          targetRef.current;
      }
    });
  }, [refs]);

  return targetRef;
}
